import React, { useEffect } from "react";
import AddCategory from "../component/inspection/addCategory";
import * as incpectionAction from "../../../redux/actions/incpectionAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { ORG_ID, GRID_DEFAULT_PAGE_SIZE } from "../../../constant/constant";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  INSPECTION_CATEGORY,
  INSPECTION_SUB_CATEGORY,
  INSPECTIONS,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { getPreviousRoute } from "../../../utils/routeTracker";

const InspectionCategoriesContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const defaultData = {
    searchText: "",
    organisationId: ORG_ID(),
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    allowPaging: true,
  };

  const getCategoriesList = useSelector((state) => state.getCategoriesList);

  const getCategoriesListData = (data) => {
    dispatch(incpectionAction.getCategoriesList(data));
    dispatch(incpectionAction.getConfigureCategoriesFilterObj(data));
  };
  const adminAddUpdateCategory = useSelector(
    (state) => state.adminAddUpdateCategory
  );
  const isLoading = useSelector((state) => state.getCategoriesList?.isLoading);
  const showLoader = useSelector(
    (state) => state.adminAddUpdateCategory?.isLoading
  );
  const [clearCategory, setClearCategory] = useState(false);

  const onSubmit = (data) => {
    setClearCategory(true);
    dispatch(incpectionAction.adminAddUpdateCategory(data));
  };
  useEffect(() => {
    if (
      adminAddUpdateCategory?.status === "SUCCESS" &&
      adminAddUpdateCategory?.isLoading === false &&
      clearCategory
    ) {
      toast("Category Added successfully");
    }
  }, [adminAddUpdateCategory]);

  useEffect(() => {
    getCategoriesListData(
      getCategoriesList?.filterObj ? getCategoriesList.filterObj : defaultData
    );
  }, []);

  useEffect(() => {
    const allowedRoutes = [
      INSPECTION_CATEGORY,
      INSPECTIONS,
      INSPECTION_SUB_CATEGORY,
    ];
    const currentPathname = location.pathname;
    if (currentPathname === INSPECTION_CATEGORY) {
      const previousRoute = getPreviousRoute();
      if (previousRoute && !allowedRoutes.includes(previousRoute)) {
        dispatch(incpectionAction.getConfigureCategoriesFilterObj(defaultData));
        getCategoriesListData(defaultData);
      }
    }
  }, [location.pathname, dispatch]);

  return (
    <>
      {checkPrivileges([12, 120, 121, 122, 4]) ? (
        <>
          {showLoader && <Loader />}

          <AddCategory
            getCategoriesList={
              isLoading ? [] : getCategoriesList?.data?.keyValues
            }
            recordsCount={getCategoriesList?.data?.recordsCount}
            getCategoriesListData={getCategoriesListData}
            onSubmit={onSubmit}
            adminAddUpdateCategory={adminAddUpdateCategory}
            isLoading={isLoading}
            getCategoriesListDates={getCategoriesList}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default InspectionCategoriesContainer;
